import { EventServiceFactory } from './event.service.factory';

export const EventService = EventServiceFactory();
